import { PageHeader } from '@/components/primitives/PageHeader'
import { useSearchParams } from 'react-router-dom'
import { DomainsPanel } from './DomainsPanel'
import { JobsPanel } from './JobsPanel'
import { Playground } from './Playground'
import { ProxiesPanel } from './ProxiesPanel'
import { SettingsPanel } from './SettingsPanel'
import { CHIP_OFF, CHIP_ON } from './ui'

const TABS = [
  { id: 'playground', label: 'Playground' },
  { id: 'jobs', label: 'Jobs' },
  { id: 'domains', label: 'Domains' },
  { id: 'proxies', label: 'Proxies' },
  { id: 'settings', label: 'Settings' }
] as const
type TabId = (typeof TABS)[number]['id']

export function WebScraperPage() {
  const [params, setParams] = useSearchParams()
  const tab = (TABS.find((t) => t.id === params.get('tab'))?.id ??
    'playground') as TabId
  const jobId = params.get('job')

  const go = (next: TabId, job?: string | null) => {
    const p = new URLSearchParams()
    p.set('tab', next)
    if (job) p.set('job', job)
    setParams(p)
  }

  return (
    <div className="space-y-4">
      <PageHeader
        title="Web scraper"
        description="Scrape, crawl, map and extract any site. Gets past Cloudflare and most captchas, reads image only pages with vision, and turns pages into sections and structured data."
      />
      <div
        role="tablist"
        aria-label="Web scraper"
        className="flex flex-wrap gap-2"
      >
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            onClick={() => go(t.id)}
            className={tab === t.id ? CHIP_ON : CHIP_OFF}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'playground' && (
        <Playground onOpenJob={(id) => go('jobs', id)} />
      )}
      {tab === 'jobs' && (
        <JobsPanel jobId={jobId} onSelect={(id) => go('jobs', id)} />
      )}
      {tab === 'domains' && <DomainsPanel />}
      {tab === 'proxies' && <ProxiesPanel />}
      {tab === 'settings' && <SettingsPanel />}
    </div>
  )
}
